import React from 'react';
import './Success.css';
import SuccessImage from '../../../assets/Students/sucess.png'

function Success() {
    return (
        <div className='success-outer d-flex justify-content-between align-items-center w-100'>
            <div className="success-inner d-flex justify-content-between align-items-center flex-column w-100">
                <h2 className="header-text w-100 text-align-right">Success Stories</h2>
                <div className="success-lower d-flex justify-content-between align-items-center w-100">
                    
                    <div className="success-middle">
                        <img src={SuccessImage} alt="" />
                    </div>
                    <div className="success-right d-flex justify-content-between align-items-center flex-column">
                        <p className="paragraph-text w-100 ">3000+ Students Placed in 13 Years</p>
                        <p className="secondary-header w-100 placed-students-header">Students placed In</p>
                        <div className="success-companies d-flex justify-content-start align-items-center">
                            <i className='bx  bx-check-circle'></i>
                            <p className="paragraph-text">Royal Caribbean International</p>
                        </div>
                        <div className="success-companies d-flex justify-content-start align-items-center">
                            <i className='bx  bx-check-circle'></i>
                            <p className="paragraph-text">Princess Cruise</p>
                        </div>
                        <div className="success-companies d-flex justify-content-start align-items-center">
                            <i className='bx  bx-check-circle'></i>
                            <p className="paragraph-text">Cunard Line</p>
                        </div>
                        <div className="success-companies d-flex justify-content-start align-items-center">
                            <i className='bx  bx-check-circle'></i>
                            <p className="paragraph-text">Disney Cruise Line</p>
                        </div>
                        <div className="success-companies d-flex justify-content-start align-items-center">
                            <i className='bx  bx-check-circle'></i>
                            <p className="paragraph-text">Marriot Hotels & Resorts</p>
                        </div>
                        
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Success
